import { Locale } from "../schema/Locale.js";

const dayLongFormat: Record<Locale, Intl.DateTimeFormat> = {
	[Locale.cs]: new Intl.DateTimeFormat("cs-CZ", { weekday: "long", timeZone: "Europe/Prague" }),
};

export function toDayLong(date: number | Date | string, locale: Locale): string {
	return dayLongFormat[locale].format(typeof date === "string" ? new Date(date) : date);
}
